import { useNavigate } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { BUSINESS } from "@/content/site";

export const useQuote = () => {
  const navigate = useNavigate();
  return (service) => {
    if (service) window.dispatchEvent(new CustomEvent("sed:quote", { detail: { service } }));
    if (!scrollToId("quote")) navigate("/contact#quote");
  };
};

export const QuoteButton = ({ children = "Get a Free Quote", service, variant = "primary", className = "", testId }) => {
  const quote = useQuote();
  return (
    <button type="button" onClick={() => quote(service)} data-testid={testId} className={`btn btn-${variant} group ${className}`}>
      <span className="relative z-10">{children}</span>
      <ArrowUpRight className="relative z-10 h-4 w-4 transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </button>
  );
};

export const CallButton = ({ children = "Call Now", variant = "ghost", className = "", testId }) => (
  <a href={BUSINESS.phoneHref} data-testid={testId} className={`btn btn-${variant} group ${className}`}>
    <Phone className="h-4 w-4 transition-transform duration-500 group-hover:rotate-12" />
    <span>{children}</span>
  </a>
);

export const CertLine = ({ className = "" }) => (
  <p className={`font-mono text-[11px] sm:text-xs uppercase tracking-[0.2em] text-zinc-300 ${className}`}>
    Licensed &amp; Insured <span className="text-amber-400">|</span> Tesla Certified <span className="text-amber-400">|</span> Enphase Certified <span className="text-amber-400">|</span> SolarEdge Certified
  </p>
);
